import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Grid,
  Container,
  Typography,
  Paper,
  Modal,
  FormControl,
} from '@mui/material';
import { Input } from '../Input';
import { Select } from '../Select';
import { Button as Button2 } from '../Button';
import { useLocation } from 'react-router-dom';

const CarteirinhaDigital = ({
  empresas,
  handleFormSubmit,
  handleCnpjChange,
  cnpj,
}: {
  empresas: any[];
  handleFormSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  handleCnpjChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  cnpj: string;
}) => {
  const [open, setOpen] = useState(false);
  const [selectedEmpresa, setSelectedEmpresa] = useState<any | null>(null);
  const [planos, setPlanos] = useState<any[]>([]);
  const [link, setLink] = useState<string>('');
  const [plano, setPlano] = useState<string>('');
  const [competencia, setCompetencia] = useState<number>(0);
  const location = window.location.href;
  const UrlBaseLocal = location.replace('/generate/Bussiness-Link', '');

  const Competencia = [
    {
      Id: 1,
      Sigla: 'Pré',
    },
    {
      Id: 2,
      Sigla: 'Pós',
    },
  ];
  const gerarLink = async (): Promise<string> => {
    if (!selectedEmpresa) {
      alert('Selecione uma empresa!');
      return;
    }
    if (plano == '') {
      alert('Selecione um plano!');
      return;
    }
    const url = process.env.REACT_APP_OG_API_URL;
    const rtn = await axios.get(
      `${url}/generate/Token?id_empresa=${selectedEmpresa.Id}&id_plano=${plano}`,
    );
    if (rtn.status !== 200) {
      alert('erro ao gerar Token, Favor verificar com o suporte!');
      return;
    }
    const tokenRT = rtn.data.token;

    if (tokenRT) {
      setLink(tokenRT);
    } else {
      alert('erro ao gerar Token, Favor verificar com o suporte!');
      return;
    }
  };

  const handleOpen = async (empresa: any) => {
    setSelectedEmpresa(empresa);
    setOpen(true);
    await handleBuscaPlanos(empresa.Id);
  };

  const handlePlanoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLink('');
    setPlano(event.target.value);
  };
  const handleCompetenciaChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setLink('');
    setCompetencia(Number(event.target.value));
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedEmpresa(null);
    setPlanos([]);
  };

  const handleBuscaPlanos = async (id: string) => {
    try {
      const urlBase = process.env.REACT_APP_URL_BASE;
      const token = process.env.REACT_APP_TOKEN_S4E_V2;

      const response = await axios.get(
        `${urlBase}/api/plano/planos?token=${token}&empresaId=${id}`,
      );

      const Data = response.data.dados;
      console.log('planos: ', Data);
      if (Data.length > 0) {
        setPlanos(Data);
      }
    } catch (error) {
      console.error('Erro ao buscar carteirinha:', error);
    }
  };
  console.log('empresas: ', empresas);

  return (
    <>
      <form id="form" onSubmit={handleFormSubmit}>
        <div className="flex grid min-[748px]:grid-cols-2 grid-cols-1 gap-6 items-end">
          <Input
            label="CNPJ da empresa"
            placeholder="CNPJ da empresa"
            activateMask
            mask="99.999.999/9999-99"
            value={cnpj}
            onChange={handleCnpjChange}
          />
          <Button2 text="Enviar" type="submit" />
        </div>
      </form>
      {empresas.length > 0 && (
        <Box mt={4}>
          <table width="100%">
            <thead style={{ background: '#272D65', color: '#FFFFFF' }}>
              <tr>
                <th style={{ textAlign: 'center' }}>ID Empresa</th>
                <th style={{ textAlign: 'center' }}>nome Fantasia</th>
              </tr>
            </thead>
            <tbody>
              {empresas.map((empresa, index) => (
                <React.Fragment key={index}>
                  <tr
                    onClick={() => handleOpen(empresa)}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <td style={{ textAlign: 'center' }}>{empresa.Id}</td>
                    <td style={{ textAlign: 'center' }}>
                      {empresa.NomeFantazia}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </Box>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
            backgroundColor: 'white',
            padding: '20px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
            width: '80%',
            height: '80%',
          }}
        >
          {selectedEmpresa && planos ? (
            <Box
              sx={{
                backgroundColor: '#fff',
                p: { xs: 2, md: 4 },
                borderRadius: { md: 2 },
                boxShadow: { md: 3 },
              }}
            >
              <Typography variant="h6" color="text.primary" gutterBottom>
                Resumo da Empresa
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="caption" color="text.secondary">
                    Razão Social:
                  </Typography>
                  <Typography variant="body2" color="text.primary">
                    {selectedEmpresa.RazaoSocial}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="caption" color="text.secondary">
                    Nome Fantasia:
                  </Typography>
                  <Typography variant="body2" color="text.primary">
                    {selectedEmpresa.NomeFantazia}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Typography variant="caption" color="text.secondary">
                    CNPJ:
                  </Typography>
                  <Typography variant="body2" color="text.primary">
                    {selectedEmpresa.CNPJ}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Select
                      label="Selecione o plano que será utilizado no Link :"
                      options={[]}
                      optionsFull={planos}
                      placeholder="Plano"
                      value={plano}
                      onChange={handlePlanoChange}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Select
                      label="Selecione a Competência"
                      options={[]}
                      optionsFull={Competencia}
                      placeholder="Competência"
                      value={competencia}
                      onChange={handleCompetenciaChange}
                    />
                  </FormControl>
                </Grid>

                {!link ? (
                  <Grid item xs={12}>
                    <Button2 text="Gerar Link" onClick={gerarLink} />
                  </Grid>
                ) : (
                  <>
                    <Grid item xs={12} md={6}>
                      <Typography
                        variant="h6"
                        color="text.primary"
                        gutterBottom
                      >
                        o link gerado foi:
                      </Typography>
                      <Typography variant="body2" color="text.primary">
                        {UrlBaseLocal}/empresa/incluir-funcionario/
                        {link}
                      </Typography>
                    </Grid>
                  </>
                )}
              </Grid>
            </Box>
          ) : (
            <Typography variant="h6" id="simple-modal-title">
              Carregando planos...
            </Typography>
          )}
        </div>
      </Modal>
    </>
  );
};

const GenerateLinkScreen: React.FC = () => {
  const [cnpj, setCnpj] = useState('');
  const [empresas, setEmpresas] = useState<any[]>([]);

  const handleCnpjChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setCnpj(event.target.value);
  };

  const handleFormSubmit = async (
    event: React.FormEvent<HTMLFormElement>,
  ): Promise<void> => {
    event.preventDefault();

    setEmpresas([]);
    const urlBase = process.env.REACT_APP_URL_BASE;
    const token = process.env.REACT_APP_TOKEN_S4E_V2;

    const cleanedCnpj = cnpj.replace(/[^\d]+/g, '');
    try {
      const cnpjClean = cnpj.replace(/[.\-/]/g, '');
      if (cnpjClean.length < 14) {
        alert('Cnpj deve conter 14 caracteres !!!!');
        return;
      }
      const retorno = await axios.get(
        `${urlBase}/api/empresa/BuscaEmpresas?token=${token}&cnpj=${cleanedCnpj}`,
      );
      if (retorno.status !== 200) {
        alert('erro na consulta!');
        return;
      }
      const empresasAtivas = retorno.data.dados.filter(
        x => x.CodigoSituacao == 1,
      );
      if (empresasAtivas < 1) {
        alert('nenhuma empresa ativa encontrada com o Cnpj Informado!');
        return;
      }
      setEmpresas(empresasAtivas);
    } catch (error) {
      console.error('Erro ao buscar associado:', error);
    }
  };
  return (
    <Container>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <Paper
          elevation={3}
          style={{ padding: '2rem', maxWidth: '800px', width: '100%' }}
        >
          <Typography variant="h5" component="h3" gutterBottom>
            Gere aqui o link para inclusão de Funcionários de uma empresa
          </Typography>
          <CarteirinhaDigital
            empresas={empresas}
            handleFormSubmit={handleFormSubmit}
            handleCnpjChange={handleCnpjChange}
            cnpj={cnpj}
          />
        </Paper>
      </Box>
    </Container>
  );
};

export default GenerateLinkScreen;
